
const {
    NODE_ENV,
    VUE_APP_OKTA_CLIENT_ID,
    VUE_APP_OKTA_BASE_URL,
    VUE_APP_OKTA_ISSUER,
    VUE_APP_OKTA_REDIRECT_SUFFIX
} = process.env;
export default {
    env: NODE_ENV,
    oidc: {
        clientId: VUE_APP_OKTA_CLIENT_ID,
        baseUrl: VUE_APP_OKTA_BASE_URL,
        issuer: VUE_APP_OKTA_ISSUER,
        redirectUri: window.origin + VUE_APP_OKTA_REDIRECT_SUFFIX,
        scopes: ['openid', 'profile', 'email', 'user_profile'],
        pkce: true,
        testing: {
            disableHttpsCheck: false
        }
    }
};
